export const resellerLevelList = [
  "inactive reseller",
  "power reseller",
  "master reseller",
  "champion reseller",
];
